const SHOP_KEYS = ['shop_config', 'pickup_leadtime']

const SHOP_SCHEMA = {
  fields: [
    {
      type: "jsonField",
      model: "shop_config"
    },
    {
      type: "input",
      inputType: "number",
      label: "Pickup Leadtime",
      model: "pickup_leadtime",
      hint: "In minutes",
      required: true,
      placeholder: "Minimum pickup time delta"
    }
  ]
};


export const SHOP_OPTIONS = {
  validateAfterLoad: false,
  validateAfterChanged: true,
  validateAsync: true
};

export default {
  SHOP_SCHEMA,
  SHOP_OPTIONS,
  SHOP_KEYS
};
